<template>
  <div>
    <div class="background_home">
      <div class="home_div">
        <img
          id="img_home"
          class="background_home_img"
          src="../../assets/img/vip/home2.png"
          alt=""
        />
        <div class="details_top">
          <div class="foreword">
            <div class="foreword-zi">
              尊贵的VIP客户，感谢您的宝贵时间和真诚分享
            </div>
            <div class="foreword-zi">我们将持续为您提供更好的产品和服务</div>
          </div>
        </div>
      </div>

      <div class="background_home_img_box">
        <div class="background_home_img_box_di"></div>
        <div class="details">
          <!-- <div class="foreword">
            尊贵的VIP客户，感谢您的宝贵时间和真诚分享
            我们将持续为您提供更好的产品和服务
          </div> -->
          <div class="honoredGuest">嘉宾基本信息</div>
          <el-form
            :model="ruleForm"
            ref="ruleForm"
            label-width="100px"
            label-position="top"
            class="demo-ruleForm"
          >
            <el-form-item class="vip_designation vip_designation2">
              <div class="vip_designation_name">
                客户VIP编号: {{ ruleForm.name }}
              </div>
            </el-form-item>

            <el-form-item class="ChooseSpacing" id="page1">
              <div class="ChooseSpacing_box">
                <div class="number">1</div>
                <div class="issue">请问您之前是否有用过祛皱产品？</div>
              </div>
              <el-radio-group
                class="whether vip_Rzi"
                v-model="ruleForm.answer1"
              >
                <el-radio label="是"></el-radio>
                <el-radio label="否"></el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item class="ChooseSpacing" id="page2">
              <div class="ChooseSpacing_box">
                <div class="number">2</div>
                <div class="issue">是否使用过肉毒针等医美注射类产品？</div>
              </div>
              <el-radio-group
                class="whether vip_Rzi"
                v-model="ruleForm.answer2"
              >
                <el-radio label="是"></el-radio>
                <el-radio label="否"></el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item class="ChooseSpacing" id="page3">
              <div class="ChooseSpacing_box">
                <div class="number">3</div>
                <div class="issue">您目前光顾医美机构的频率是怎样的？</div>
              </div>
              <el-radio-group
                class="whetherMulti vip_Rzi"
                v-model="ruleForm.answer3"
              >
                <el-radio label="每月多次"></el-radio>
                <el-radio label="每月一次"></el-radio>
                <el-radio label="每年多次"></el-radio>
                <el-radio label="每年一次"></el-radio>
                <el-radio label="多年一次"></el-radio>
                <el-radio label="从不"></el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item class="ChooseSpacing" id="page4">
              <div class="ChooseSpacing_box">
                <div class="number">4</div>
                <div class="issue">是否愿意使用涂抹类型的祛皱新产品？</div>
              </div>
              <el-radio-group
                class="whether vip_Rzi"
                v-model="ruleForm.answer4"
              >
                <el-radio label="是"></el-radio>
                <el-radio label="否"></el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item class="ChooseSpacing" id="page5">
              <div class="ChooseSpacing_box">
                <div class="number">5</div>
                <div class="issue">
                  祛皱产品的选定您更看重的是什么
                  <i class="multiple">（多选）</i>
                </div>
              </div>
              <el-checkbox-group class="CHANGJ" v-model="ruleForm.answer5">
                <el-checkbox label="产品品牌" name="type"></el-checkbox>
                <el-checkbox label="产品使用功效" name="type"></el-checkbox>
                <el-checkbox label="美妆达人推荐" name="type"></el-checkbox>
                <el-checkbox label="小红书种草" name="type"></el-checkbox>
                <el-checkbox label="朋友推荐" name="type"></el-checkbox>
                <el-checkbox label="产品服务" name="type"></el-checkbox>
                <el-checkbox label="其他" name="type"></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item class="ChooseSpacing" id="page6">
              <div class="ChooseSpacing_box">
                <div class="number">6</div>
                <div class="issue">
                  <!-- <div class="special_curlycue">Pe Beautie</div>
                  普罗敦
                  <div class="sup">®</div> -->
                  本产品是否有听说过？
                </div>
              </div>
              <el-radio-group
                class="whether vip_Rzi"
                v-model="ruleForm.answer6"
              >
                <el-radio label="是"></el-radio>
                <el-radio label="否"></el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item class="ChooseSpacing" id="page7">
              <div class="ChooseSpacing_box">
                <div class="number">7</div>
                <div class="issue">
                  <!-- <div class="special_curlycue">Pe Beautie</div>
                  普罗敦
                  <div class="sup">®</div> -->
                  本产品使用后的体验如何？
                </div>
              </div>
              <el-radio-group
                class="whether vip_Rzi"
                v-model="ruleForm.answer7"
              >
                <el-radio label="很满意，使用体验佳，有明显效果"></el-radio>
                <el-radio label="满意，效果已渐显"></el-radio>
                <el-radio label="可以，期待效果中"></el-radio>
                <el-radio label="使用体验不理想"></el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item class="ChooseSpacing" id="page8">
              <div class="ChooseSpacing_box">
                <div class="number">8</div>
                <div class="issue">
                  <!-- <div class="special_curlycue">Pe Beautie</div>
                  普罗敦
                  <div class="sup">®</div> -->
                  本产品一支可以用于您面部5-10处的祛皱紧致，请问使用中剂量是否足够？
                </div>
              </div>
              <el-radio-group
                class="whether vip_Rzi"
                v-model="ruleForm.answer8"
              >
                <el-radio label="是"></el-radio>
                <el-radio label="否"></el-radio>
                <el-radio label="其他（欢迎您详细描述反馈）"></el-radio>
              </el-radio-group>
              <el-input
                type="textarea"
                v-model="ruleForm.rests8"
                show-word-limit
                class="input_text"
              >
              </el-input>
            </el-form-item>
            <el-form-item class="ChooseSpacing" id="page9">
              <div class="ChooseSpacing_box">
                <div class="number">9</div>
                <div class="issue">
                  您是否愿意继续使用或推荐朋友使用抗皱产品帮助护理肌肤？
                  <!-- <div class="special_curlycue">Pe Beautie</div>
                  普罗敦<sup>®</sup> -->
                </div>
              </div>
              <el-radio-group
                class="whether vip_Rzi"
                v-model="ruleForm.answer9"
              >
                <el-radio label="是"></el-radio>
                <el-radio label="否"></el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item class="ChooseSpacing" id="page10">
              <div class="ChooseSpacing_box">
                <div class="number">10</div>
                <div class="issue">
                  对产品有哪些改进建议？
                  <i class="multiple">（多选）</i>
                </div>
              </div>
              <el-checkbox-group class="CHANGJ" v-model="ruleForm.answer10">
                <el-checkbox label="产品包装" name="type"></el-checkbox>
                <el-checkbox label="产品功效" name="type"></el-checkbox>
                <el-checkbox label="皮肤感受" name="type"></el-checkbox>
                <el-checkbox label="产品价格" name="type"></el-checkbox>
                <el-checkbox
                  class="whetherLine"
                  label="其他（欢迎您详细描述反馈）"
                  value='1444'
                  name="type"
                ></el-checkbox>
                <el-input
                  type="textarea"
                  v-model="ruleForm.rests10"
                  show-word-limit
                  class="input_text"
                >
                </el-input>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item class="ChooseSpacing" id="page11">
              <div class="ChooseSpacing_box">
                <div class="number">11</div>
                <div class="issue">您目前光顾医美机构的频率是怎样的？</div>
              </div>
              <el-radio-group
                class="whetherMulti vip_Rzi"
                v-model="ruleForm.answer11"
              >
                <el-radio label="0-1000元"></el-radio>
                <el-radio label="1000-2000"></el-radio>
                <el-radio label="2000-5000"></el-radio>
                <el-radio label="5000-10000"></el-radio>
                <el-radio label="10000以上"></el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item class="ChooseSpacing" id="page12">
              <div class="ChooseSpacing_box">
                <div class="number">12</div>
                <div class="issue">您目前光顾医美机构的频率是怎样的？</div>
              </div>
              <el-radio-group
                class="whetherMulti vip_Rzi"
                v-model="ruleForm.answer12"
              >
                <el-radio label="0-1000元"></el-radio>
                <el-radio label="1000-2000"></el-radio>
                <el-radio label="2000-5000"></el-radio>
                <el-radio label="5000-10000"></el-radio>
                <el-radio label="10000以上"></el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item class="vip_designation" id="page13">
              <div class="ChooseSpacing_box2">
                <div class="number">13</div>
                <div class="issue">您的年龄</div>
              </div>
              <el-input v-model.number="ruleForm.age"></el-input>
            </el-form-item>
            <el-form-item class="ChooseSpacing" id="page14">
              <div class="ChooseSpacing_box2">
                <div class="number">14</div>
                <div class="issue">您的性别</div>
              </div>
              <el-radio-group class="vip_Rzi" v-model="ruleForm.gender">
                <el-radio label="男">男</el-radio>
                <el-radio label="女">女</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item class="vip_designation">
              <div class="ChooseSpacing_box2">
                <div class="number">15</div>
                <div class="issue">
                  您的职业<i class="multiple">（可不填）</i>
                </div>
              </div>
              <el-input v-model.number="ruleForm.occupation"></el-input>
            </el-form-item>
            <el-form-item class="vip_designation">
              <div class="ChooseSpacing_box2">
                <div class="number">16</div>
                <div class="issue">
                  您的电话<i class="multiple">（可不填）</i>
                </div>
              </div>
              <el-input v-model.number="ruleForm.phone_num"></el-input>
            </el-form-item>
            <el-form-item class="ChooseSpacing" style="margin-bottom: 0px !important;">
              <div class="base_introduce">尊贵的VIP客户，欢迎您继续关注，</div>
              <div class="base_introduce">为您的美丽常驻提供无限可能。</div>
            </el-form-item>
            <el-form-item class="t_bu">
              <el-button
                class="t_button"
                type="primary"
                @click="submitForm('ruleForm')"
                >提 交</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
      <img
        class="background_home_img_b"
        src="../../assets/img/vip/base.png"
        alt=""
      />
    </div>
  </div>
</template>

<script>
import { VipAdd, serialGet } from "../../api/index";
export default {
  data() {
    var checkAge = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("年龄不能为空"));
      }
      if (!Number.isInteger(value)) {
        callback(new Error("请输入数字值"));
      } else {
        callback();
      }
    };
    return {
      dialogVisible: false,
      serial: "",
      ruleForm: {
        gender: "",
        occupation: "",
        age: "",
        name: "",
        phone_num: "",
        answer1: "",
        answer2: "",
        answer3: "",
        answer4: "",
        answer5: [],
        answer6: "",
        answer7: "",
        answer8: "",
        answer9: "",
        answer10: [],
        answer11: "",
        answer12: "",
        rests8: "",
        rests10:''
      },
    };
  },
  mounted() {
    let item = JSON.parse(localStorage.getItem("existVip"));
    if (item) {
      this.ruleForm = item;
    }
    this.serialNumber();
  },
  methods: {
    serialNumber() {
      serialGet({}).then((res) => {
        this.ruleForm.name = res.data;
        localStorage.setItem("user_token", JSON.stringify(res.data));
      });
    },
    djClick() {
      this.dialogVisible = true;
    },
    skip() {
      window.open("http://www.YsteMed.com", "_self");
      let obj = this.ruleForm;
      localStorage.setItem("existVip", JSON.stringify(obj));
    },
    move(key) {
      var img = document.getElementById("img_home");
      var PageId = document.querySelector("#page" + key);
      window.scrollTo({
        top: PageId.offsetTop + img.offsetHeight,
        behavior: "smooth",
      });
      console.log(PageId)
      if (key == 13) {
        this.$message({
          message: "请输入年龄",
          customClass:'message_class',
          duration: 2000,
        });
      } else if (key == 14) {
        this.$message({
          message: "请选择性别",
          customClass:'message_class',
          duration: 2000,
        });
      } else {
        this.$message({
          message: "请选择",
          customClass:'message_class',
          duration: 2000,
        });
      }
    },

    submitForm(ruleForm) {
      let rewer8 = ''
      if (this.ruleForm.answer8 == "其他（欢迎您详细描述反馈）") {
        rewer8 = this.ruleForm.rests8;
      }else {
        rewer8 = this.ruleForm.answer8
      }
      let list =[]
      if (this.ruleForm.rests10) {
        this.ruleForm.answer10.forEach((item, index) => {
          if (item == "其他（欢迎您详细描述反馈）") {
            list.push(this.ruleForm.rests10) 
          }else {
            list.push(this.ruleForm.answer10[index]) 
          }
        });
      }
      if (!this.ruleForm.answer1) {
        this.move("1");
      } else if (!this.ruleForm.answer2) {
        this.move("2");
      } else if (!this.ruleForm.answer3) {
        this.move("3");
      } else if (!this.ruleForm.answer4) {
        this.move("4");
      } else if (this.ruleForm.answer5.length == 0) {
        this.move("5");
      } else if (!this.ruleForm.answer6) {
        this.move("6");
      } else if (!this.ruleForm.answer7) {
        this.move("7");
      } else if (!this.ruleForm.answer8) {
        this.move("8");
      } else if (!this.ruleForm.answer9) {
        this.move("9");
      } else if (this.ruleForm.answer5.length == 0) {
        this.move("10");
      } else if (!this.ruleForm.answer11) {
        this.move("11");
      } else if (!this.ruleForm.answer12) {
        this.move("12");
      } else if (!this.ruleForm.age) {
        this.move("13");
      } else if (!this.ruleForm.gender) {
        this.move("14");
      }else {
          VipAdd({
            sex: this.ruleForm.gender,
            age: this.ruleForm.age + "",
            name: this.ruleForm.name,
            phone_num: this.ruleForm.phone_num,
            position: this.ruleForm.occupation,
            answer1: this.ruleForm.answer1,
            answer2: this.ruleForm.answer2,
            answer3: this.ruleForm.answer3,
            answer4: this.ruleForm.answer4,
            answer5: this.ruleForm.answer5,
            answer6: this.ruleForm.answer6,
            answer7: this.ruleForm.answer7,
            answer8: rewer8,
            answer9: this.ruleForm.answer9,
            answer10: list,
            answer11: this.ruleForm.answer11,
            answer12: this.ruleForm.answer12,
          }).then((res) => {
            if (res.success) {
              this.$message({
                message: "提交成功",
                customClass:'message_class',
                duration: 2000,
                type: "success",
              });
              this.skip();
            } else {
              this.$message({
                message: res.msg,
                duration: 2000,
              });
            }
          });
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/css/vip/home";
</style>


// WEBPACK FOOTER //
// src/views/vip/index.vue